// extracted by mini-css-extract-plugin
module.exports = {"small":"separator-module__small--s9wYm","big":"separator-module__big--Qh9p_"};